/* tslint:disable */

declare var Object: any;
export interface SFBusinesstripSettingInterface {
  "id"?: number;
}

export class SFBusinesstripSetting implements SFBusinesstripSettingInterface {
  "id": number;
  constructor(data?: SFBusinesstripSettingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFBusinesstripSetting`.
   */
  public static getModelName() {
    return "SFBusinesstripSetting";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFBusinesstripSetting for dynamic purposes.
  **/
  public static factory(data: SFBusinesstripSettingInterface): SFBusinesstripSetting{
    return new SFBusinesstripSetting(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFBusinesstripSetting',
      plural: 'SFBusinesstripSettings',
      path: 'SFBusinesstripSettings',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFBusinesstripSetting.ts